import { QueryKey } from '@/composable/services/utilities/query-key'
import { healthRepository } from '@/repositories/health-repository'
import { useQuery } from '@tanstack/vue-query'

export const useHealthCheck = () => {
  return {
    serverVersion: () =>
      useQuery({
        queryKey: [QueryKey.Health],
        queryFn: healthRepository.serverVersion,
      }),
  }
}
